var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMobileMenuArrowDown = function SvgIconMobileMenuArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "41228BD2-CA80-4783-AEB1-254A5D157B5B")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rwd",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(-337.000000, -179.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 1.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "pozycja/rwd/menu/zwini\\u0119te",
    transform: "translate(-2.487296, 154.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/control/back",
    transform: "translate(347.500000, 32.500000) scale(-1, 1) rotate(-90.000000) translate(-347.500000, -32.500000) translate(340.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    points: "7.5047441 0.835763785 0.835354614 7.5 7.5047441 14.1583148"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMobileMenuArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_mobile_menu_arrow_down.39c674b9.svg";
export { ForwardRef as ReactComponent };